import "@aws-amplify/ui-react/styles.css";
import React from "react";
import NotFound from "./NotFound";
import { LoadingBlock } from "../controls/LoadingBlock";
import { AnnotateImage } from "../controls/AnnotateImage";
import { deleteDescriptor, getDescriptor } from "../clients/photo-upload-client";
import { ImageDescriptorData } from "../clients/data-service";
import { Alert, AlertDescription, AlertIcon, AlertTitle, Box, Button, Center, Divider, Modal, ModalBody, ModalContent, ModalHeader, ModalOverlay, Spinner, Text, VStack } from "@chakra-ui/react";
import NavButton from "../controls/NavButton";
import { deleteTeam } from "../clients/team-upload";

class DeleteImagePage extends React.Component<{}, {liveDescriptor?: ImageDescriptorData, uploadingInProgress: boolean, isDeleted: boolean}> {

    imageId : string;
    constructor(props) {
        super(props);
        this.state = {
            uploadingInProgress: false,
            isDeleted: false
        };
        
        this.LoadData = this.LoadData.bind(this);
        this.DeleteTeamAndImage = this.DeleteTeamAndImage.bind(this);

        const location = window.location;
        const paths = location.pathname.split('/');
        this.imageId = paths[paths.length - 1];

        
        this.LoadData();
    }

    async LoadData() : Promise<void> {
        const liveImageDesc = await getDescriptor(this.imageId);
        // this.setState(prev => {
        //     const newState = structuredClone(prev);
        //     newState.liveDescriptor = liveImageDesc;
        //     return newState;
        // });
        this.setState({ liveDescriptor: liveImageDesc });
    }

    async DeleteTeamAndImage() {
        const teamId = this.state?.liveDescriptor?.teams[0];
        this.setState({ uploadingInProgress: true });
        
        await deleteTeam(teamId!);
        await deleteDescriptor(this.imageId);
        this.setState({ uploadingInProgress: false });
        this.setState({ isDeleted: true });
    }

    componentDidMount() {
        
    }
    render() {
        if (this.state.liveDescriptor == null) {
            return <LoadingBlock />;
        }

        if (this.state.liveDescriptor.id == null || this.state.liveDescriptor.teams.length == 0) {
            return <NotFound message="Image Not Found" />;
        }
        if (this.state.isDeleted) {
            return  (<>
             <Box h='80%'>
                <Center>
                <Alert status='success'>
                    <AlertIcon />
                        Deleted
                    </Alert>
                </Center>
                </Box>
            </>);
        }
        return (
            <>
            <Box h='80%'>
                <Center>
                    <VStack m={30}>
                        <Alert status='error'>
                            <AlertIcon />
                            <AlertTitle>Are you sure you want to delete this image?</AlertTitle>
                            <AlertDescription>This is a PERMANENT action.</AlertDescription>
                        </Alert>
                        <Divider />
                        <Text>TEAM: {this.state.liveDescriptor.teams[0]}</Text>
                        <Divider />
                        <Button onClick={this.DeleteTeamAndImage} colorScheme="red">Delete Image & Team Results</Button>
                    </VStack>
                </Center>
            </Box>
            <Modal isOpen={this.state.uploadingInProgress} onClose={() => { }} isCentered>
                    <ModalOverlay />
                    <ModalContent>
                        <ModalHeader textAlign='center'>
                            Saving
                        </ModalHeader>
                        <ModalBody>
                            <Center p={4}>
                                <Spinner />
                            </Center>
                        </ModalBody>
                    </ModalContent>
                </Modal>
            </>
        );
    }
}

export default DeleteImagePage;